<template>
  <section id="section-about-us" class="section-about-us">
    <h1>{{ $t('aboutUsTitle') }}</h1>
    <div class="managment">
      <div class="managment_1">
        <img
          :src="`${staticUrl}/images/offer/offer_manager_2.webp`"
          :alt="'altImageDefault'"
        />
        <div>
          <h3>{{ $t('manager1') }}</h3>
          <ul>
            <li>
              <span>{{ $t('manager1_skill_1') }}</span>
            </li>
            <li>
              <span>{{ $t('manager1_skill_2') }}</span>
            </li>
            <li>
              <span>{{ $t('manager1_skill_3') }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="managment_2">
        <img
          :src="`${staticUrl}/images/offer/offer_manager_1.webp`"
          :alt="'altImageDefault'"
        />
        <div>
          <h3>{{ $t('manager2') }}</h3>
          <ul>
            <li>
              <span>{{ $t('manager2_skill_1') }}</span>
            </li>
            <li>
              <span>{{ $t('manager2_skill_2') }}</span>
            </li>
            <li>
              <span>{{ $t('manager2_skill_3') }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div :class="['images', {images_right: right}]">
      <img
        :src="`${staticUrl}/images/offer/offer_about_us_right.webp`"
        :alt="'altImageDefault'"
      />
      <img
        :src="`${staticUrl}/images/offer/offer_about_us_center.webp`"
        :alt="'altImageDefault'"
      />
      <img
        :src="`${staticUrl}/images/offer/offer_about_us_left.webp`"
        :alt="'altImageDefault'"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import {useRuntimeConfig} from '#imports';
import {useDirectionStore} from '~/store/direction.store';

const direction = useDirectionStore();
const right = computed(() => direction.$state.isRight);
const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
</script>

<style scoped lang="scss">
.section-about-us {
  height: 100%;
  width: 100%;
  margin-top: $m-20;
  padding-top: $m-22;
  display: flex;
  flex-direction: column;
  gap: $g-18;

  .managment {
    display: flex;
    gap: $g-17;
    img {
      border-radius: 50%;
      width: 160px;
      height: 160px;
    }

    &_1 {
      display: flex;
      height: fit-content;
      width: 50%;
      gap: $g-8;

      h3 {
        margin-top: $m-17;
      }
    }
    &_2 {
      display: flex;
      height: fit-content;
      width: 50%;
      gap: $g-8;

      h3 {
        margin-top: $m-17;
      }
    }
    @media (max-width: $lg) {
      &_1 {
        flex-direction: column;
        align-items: center;
      }
      &_2 {
        flex-direction: column;
        align-items: center;
      }
      h3 {
        margin-top: $m-0;
        text-align: center;
      }
    }
    @media (max-width: $md) {
      flex-direction: column;
      &_1 {
        width: 100%;
        flex-direction: column;
        align-items: center;
      }
      &_2 {
        width: 100%;
        flex-direction: column;
        align-items: center;
      }
      h3 {
        margin-top: $m-0;
        text-align: center;
      }
    }

    @media (max-width: $md) {
      gap: $g-5;
    }
  }

  .images {
    position: relative;
    height: 100%;
    margin-top: $m-2;
    margin-bottom: $m-33;
    img {
      border-radius: $br-5;
      &:nth-child(1) {
        max-width: 337px;
      }
      &:nth-child(2) {
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        top: $m-5;
        z-index: 2;
        max-width: 548px;
      }
      &:nth-child(3) {
        position: absolute;
        right: 0px;
        top: 0px;
        z-index: 1;
        max-width: 337px;
      }
      @media (max-width: $md) {
        display: flex;
        justify-content: center;
        flex-direction: column;
        &:nth-child(1) {
          position: unset;
          max-width: unset;
          width: 100%;
          margin-bottom: $m-5;
        }
        &:nth-child(2) {
          position: unset;
          max-width: unset;
          transform: translate(0%);
          width: 100%;
          margin-bottom: $m-5;
        }
        &:nth-child(3) {
          max-width: unset;
          position: unset;
          width: 100%;
        }
      }
    }
    @media (max-width: $md) {
      margin-bottom: $m-0;
    }

    &_right {
      img {
        &:nth-child(3) {
          left: 0px;
          right: unset;
        }
      }
    }
  }

  @media (min-width: 2000px) {
    min-height: 1000px;
  }

  @media (max-width: $lg) {
    margin-top: $m-0;
    padding-top: $m-10;
  }
  @media (max-width: $md) {
    gap: $g-5;
  }
}

h1 {
  @include headline-h1;
  text-align: center;
  margin: 0px;
}
h3 {
  @include headline-h3;
  margin: 0px;
}
ul {
  padding-inline-start: 28px;
  li {
    @include launcher-p1;
    color: var(--var-blue-50);
    span {
      color: var(--var-black-200);
    }
  }

  @media (max-width: $lg) {
    padding-inline-start: 20px;
  }
}
</style>
